<template>
    <dd-form-page
        @submit="onSubmit"
        :loading="loadingPage || loadingEditPage"
        :savedAt="savedAt"
        :savePerStep="true"
        ref="formPage"
        :success-message="`Polis is succesvol opgeslagen`"
        :header="pageHeader">
      <template #steps>
        <dd-step :id="PolicyFormStepsEnum.POLICY_TYPE" title="Polis Type">
          <PolicyType></PolicyType>
        </dd-step>
        <dd-step :id="PolicyFormStepsEnum.DETAILS" title="Basis Gegevens">
          <CreateOrEditDetails ></CreateOrEditDetails>
        </dd-step>
        <dd-step :id="PolicyFormStepsEnum.COVERAGES" title="Dekkingen">
          <Coverages v-if="!loadingPage && viewOptions" ></Coverages>
          <dd-loading-indicator v-if="loadingViews" message="Dekkingen worden opgehaald..."></dd-loading-indicator>
        </dd-step>
        <dd-step :id="PolicyFormStepsEnum.PREMIUMS" title="Premies">
          <Premiums></Premiums>
        </dd-step>
      </template>
  </dd-form-page>
</template>

<script>
import store from "./store";
import CreateOrEditDetails from '../components/CreateOrEditDetails.vue';
import Coverages from '../components/Coverages.vue';
import PolicyType from '../components/PolicyType.vue';
import Premiums from '../components/Premiums.vue';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import Overview from './components/Overview.vue';
import AttachableCategoryTemplateTypeEnum from "../../../enums/AttachableCategoryTemplateTypeEnum";
import genericStore from "../store";
import PolicyFormStepsEnum from '~/enums/PolicyFormStepsEnum';
export default {
  name: "PolicyEditPage",
  components: {
    CreateOrEditDetails,
    PolicyType,
    Coverages,
    Premiums,
    Overview,
  },
  beforeCreate() {
    if (!('$_generic_insurance' in this.$store._modules.root._children)) {
      this.$store.registerModule('$_generic_insurance', genericStore)
    }
    const STORE_KEY = '$_policy_edit'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  created() {
    this.setCategory({id: AttachableCategoryTemplateTypeEnum.INSURANCE, name: 'Polissen'});
    this.setCustomerId(this.$route.params.customer);
    this.setPolicyId(this.policyId);
    this.getPolicy();
    this.setPackageId(this.packageId);
    if(!this.isSinglePolicy) {
      this.getPackage();
    }
    this.getInitialCreateOrEditPageData();
    this.getInitialEditPageData();
  },
  computed: {
    pageHeader() {
      return `Polis` + (this.policy ? ` ${this.policy.name} `: ' ') +  'bewerken';
    },
    PolicyFormStepsEnum() {
      return PolicyFormStepsEnum;
    },
    policyId() {
      return this.$route.params.policy;
    },
    packageId() {
      return this.$route.params.package;
    },
    ...mapState(`$_generic_insurance`, {
      policy:  state => state.policy,
      loadingViews: state => state.loadingViews,
    }),
    ...mapGetters(`$_generic_insurance`, {
      form: 'form',
      viewOptions: 'viewOptions',
      loadingPage: 'loadingPage',
      isSinglePolicy: 'isSinglePolicy',
    }),
    ...mapState(`$_policy_edit`, {
      loadingEditPage: 'loadingEditPage',
      savedAt: 'savedAt',
    }),
    ...mapGetters(`$_form_page`, {
      errorObjects: 'errorsObject',
    }),
    header() {
      return 'Polis bewerken';
    },
  },
  methods: {
    ...mapMutations({
      setCategory: 'SET_CATEGORY',
    }),
    ...mapMutations(`$_generic_insurance`, {
      'setCustomerId': 'SET_CUSTOMER_ID',
      'setPolicyId': 'SET_POLICY_ID',
      'setPackageId': 'SET_PACKAGE_ID',
      'resetState': 'resetState',
    }),
    ...mapActions(`$_generic_insurance`, {
      getPackage: 'getPackage',
      getPolicy: 'getPolicy',
      savePolicy: 'savePolicy',
      getInitialCreateOrEditPageData: "getInitialCreateOrEditPageData",
    }),
    ...mapActions(`$_policy_edit`, {
      getInitialEditPageData: 'getInitialEditPageData',
    }),
    goToStep(step) {
      this.$refs.formPage.goToStep(parseInt(step));
    },
    onSubmit() {
      this.savePolicy();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
